// PHASE 1: What would your ideal space truly mean to you?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'deeperSpaceMotivation'

const OPTIONS = [
  {
    value: 'Personal sanctuary',
    translationKey:
      'pages.onboarding.v2.deeperSpaceMotivation.options.sanctuary',
    emoji: '🏡',
  },
  {
    value: 'Pride and confidence',
    translationKey: 'pages.onboarding.v2.deeperSpaceMotivation.options.pride',
    emoji: '✨',
  },
  {
    value: 'Better mental health',
    translationKey:
      'pages.onboarding.v2.deeperSpaceMotivation.options.mentalHealth',
    emoji: '🧘',
  },
  {
    value: 'Stronger relationships',
    translationKey:
      'pages.onboarding.v2.deeperSpaceMotivation.options.relationships',
    emoji: '👨‍👩‍👧',
  },
  {
    value: 'More productive life',
    translationKey:
      'pages.onboarding.v2.deeperSpaceMotivation.options.productivity',
    emoji: '🚀',
  },
  {
    value: 'Finally feel settled',
    translationKey: 'pages.onboarding.v2.deeperSpaceMotivation.options.settled',
    emoji: '🌱',
  },
]

export default function DeeperSpaceMotivationPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What would your ideal space truly mean to you?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.deeperSpaceMotivation.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
